import MojeId from './MojeId';

export default MojeId;
